import React, { useEffect, useRef, useState } from 'react'
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Row, Col, Button } from 'reactstrap'
import { MaterialReactTable } from 'material-react-table';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllService } from '../../../slices/services/thunk';
import { useColumns } from './constants/coloumns';
import { Loader } from '../../Utils/Loader';
import moment from 'moment';
import { handleExportData } from '../../Utils/ExportToCsv';
import { setEditSuccessMessage, setSuccessMessage } from '../../../slices/toastMessage/action';
import { ToastContainer, toast } from 'react-toastify';
import { exportDataForService } from './constants/exportDataForService';
import { PAGE_TITLES } from '../../Common/constants';
import { MenuItem } from "@mui/material";
import CommonModal from '../../Utils/CommonModal';
import { deleteService } from '../../../slices/services/deleteservice/thunk';
import { getConfig } from '../../../slices/services/addservice/eventconfiguration/thunk';
import { bulkDelete } from '../../../slices/BulkDelete/thunk';
import { useColumnSettings } from '../../Utils/useColumnSettings';
import { getView } from '../../../slices/View/thunk';
import { hasPermission } from '../../Utils/UtilityFunctions';

function ServicesListings() {
    const [services, setServices] = useState([])
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [messageForPopUp, setMessageForPopUp] = useState('')
    const [serviceName, setServiceName] = useState("");
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const [serviceArray, setServiceArray] = useState([]);
    const allServiceData = [];
    const allStartDate = [];
    const allEndDate = [];
    const allModifyDate = [];
    const isBundle = [];
    const isProvisioning = [];
    const isUsageAttribute = [];
    let navigate = useNavigate()
    const dispatch = useDispatch();
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const servicePermission = hasPermission(permissionsMap, "pricing", "service")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
    const [selectAllService, setSelectAllService] = useState(false)
    const [selectedService, setSelectedService] = useState([])
    const checkboxRef = useRef(null);
    const isMobile = window.innerWidth <= 768;
    const [modalOpen, setModalOpen] = useState(false)

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setServiceName(id);
            setModal(!modal);
        }
        else {
            setSelectedRowsForBulkDelete(id)
            setModalForBulkDelete(!modalForBulkDelete)
        }
        document.body.style.overflow = 'auto'
    };

    useEffect(() => {
        dispatch(getAllService(setLoading))
        dispatch(getConfig());
        dispatch(getView(setLoading));
    }, [dispatch])

    const serviceData = useSelector((state) => state.Services.services)

    const navigateToAddService = () => {
        let path = "/create-service"
        navigate(path)
    }
    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = selectedService.length > 0 && selectedService.length < serviceData.length;
        }
        setSelectAllService(selectedService?.length > 0 && serviceData?.length > 0 && selectedService?.length === serviceData?.length);
    }, [selectedService, serviceData.length, setSelectAllService]);

    const columns = useColumns(allStartDate, allEndDate, allModifyDate, isBundle, isProvisioning, isUsageAttribute, selectAllService, setSelectAllService, serviceData, setSelectedService, selectedService, checkboxRef, isMobile, modalOpen);
    serviceData.forEach((service, i) => {
        const EndDateObj = moment.utc(service?.Validity?.to);
        const endDate = EndDateObj.format('D MMM, YYYY');
        allEndDate[i] = endDate;
        const ModifiedDateObj = moment.utc(service?.modifiedDate);
        const modifyDate = ModifiedDateObj.format('D MMM, YYYY');
        allModifyDate[i] = modifyDate;
        const StartDateObj = moment.utc(service?.Validity?.from);
        const startTime = StartDateObj.format('D MMM, YYYY');
        allStartDate[i] = startTime;
        isBundle[i] = service?.isBundle ? "Yes" : "No";
        isProvisioning[i] = service?.provisioningAttributes ? "Provisioning" : "";
        isUsageAttribute[i] = service?.usageAttributes ? "Usage" : "";
    });

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Service Created Successfully`);
            dispatch(setSuccessMessage(false))
        }
        if (showEditSuccessMessage) {
            toast.success(`Service Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch])
    const exportData = exportDataForService(serviceData)


    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        CustomViewModal

    } = useColumnSettings('service', columns);

    useEffect(() => {
        setModalOpen(settingsModalOpen)
    }, [settingsModalOpen])
    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.SERVICE_LIST} pageTitle={PAGE_TITLES.PRICING} />
                    <ToastContainer position='top-center' />
                    <Row>
                        <Col >
                            <div className="listingjs-table " id="customerList">
                                {/* <Card> */}
                                <CardBody>
                                    <Row className="mb-0 table-responsive">
                                        {loading && (<Loader />)}
                                        {services ?
                                            <MaterialReactTable
                                                columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                                data={serviceData}
                                                enableColumnActions={true}
                                                enableDensityToggle={false}
                                                muiTableContainerProps={{
                                                    sx: {
                                                        border: '1px solid #e9ebec',
                                                    }
                                                }}
                                                displayColumnDefOptions={{
                                                    'mrt-row-actions': {
                                                        header: '',
                                                        enableHiding: true,
                                                        size: isMobile ? 55 : 50,
                                                        grow: true
                                                    },
                                                }}
                                                defaultColumn={{
                                                    // minSize: 1,
                                                    maxSize: 9001,
                                                    size: 260,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }
                                                }}
                                                layoutMode='grid'
                                                initialState={{
                                                    columnOrder: [
                                                        'checkbox',
                                                        'mrt-row-actions',
                                                        'Name',
                                                        'Service Code',
                                                        'Attributes',
                                                        'Bundled',
                                                        'Validity',
                                                        'Last Modified'
                                                    ]
                                                }}
                                                enableRowActions
                                                renderRowActionMenuItems={({ closeMenu, row }) => [
                                                    servicePermission && servicePermission?.has("clone") ? <MenuItem className='row-options' key={row.index} onClick={() => { navigate(`/clone-service/${row.original.serviceCode}`) }} ><i className="ri ri-file-copy-2-line me-2" /> Clone</MenuItem> : null,
                                                    servicePermission && servicePermission?.has("update") ? <MenuItem className='row-options' key={row.index} onClick={() => { navigate(`/edit-service/${row.original.serviceCode}`) }}><i className="bx bx-edit me-2" /> Edit</MenuItem> : null,
                                                    servicePermission && servicePermission?.has("delete") ? <MenuItem className='row-options'
                                                        key={row.index}
                                                        onClick={() => {
                                                            setMessageForPopUp(`Are you sure you want to delete this service "${row.original.name}"?`)
                                                            toggleModal(row, "single");
                                                            closeMenu();
                                                        }}
                                                    >
                                                        <i className="ri ri-delete-bin-5-line me-2" />{" "}
                                                        Delete
                                                    </MenuItem> : null,
                                                ]}
                                                positionToolbarAlertBanner='none'
                                                muiSelectCheckboxProps={{
                                                    color: 'warning'
                                                }}
                                                muiSelectAllCheckboxProps={{
                                                    color: 'warning'
                                                }}
                                                // renderTopToolbarCustomActions={({ table }) => (
                                                //     <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                //         <div className="d-flex flex-column flex-md-row">
                                                //             <Button color="secondary" className="btn-label me-2 mb-2 mb-md-0" onClick={() => { handleExportData(serviceData) }}>
                                                //                 <i className="ri-upload-line label-icon align-middle fs-16 me-2 " ></i> Export Data
                                                //             </Button>
                                                //             {servicePermission && servicePermission.permissionList.includes('create') && <Button color="secondary" className="btn-label me-2 mb-2 mb-md-0" onClick={navigateToAddService}>
                                                //                 <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i> Add Service
                                                //             </Button>}
                                                //             {selectedService?.length ? <Button color='main-color' className='btn me-2' onClick={() => {
                                                //                 const names = selectedService.map(row => row.serviceCode);
                                                //                 let uniqueServices = Array.from(new Set(names))
                                                //                 setServiceArray(uniqueServices);
                                                //                 setMessageForPopUp(`Are you sure you want to delete the selected items?`)
                                                //                 toggleModal(selectedService, "multi")
                                                //             }}>Delete</Button> : null}
                                                //         </div>
                                                //         <div className="d-flex align-items-center">
                                                //             <div color="secondary" className="btn-icon me-2 cursor-img" onClick={toggleSettingsModal}>
                                                //                 <i className="ri-settings-2-line fs-4"></i>
                                                //             </div>
                                                //         </div>
                                                //     </div>
                                                // )}
                                                renderTopToolbarCustomActions={({ table }) => (
                                                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                        <h5 className="rv-page-title mt-1">Services List</h5>

                                                        <div className="d-flex align-items-center">
                                                            <div className="d-flex ">
                                                                {servicePermission && servicePermission?.has("export") &&
                                                                    <Button
                                                                        color="secondary"
                                                                        className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                                                        onClick={() => { handleExportData(serviceData) }}
                                                                    >
                                                                        <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                                        <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                                                    </Button>}
                                                                {servicePermission && servicePermission?.has('create') &&
                                                                    <Button
                                                                        color="secondary"
                                                                        className="btn-label rv-primary-btn me-2 rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                                                        onClick={navigateToAddService}
                                                                    >
                                                                        <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                                                        <span className="ps-2 ms-2 me-1">Add Service</span>
                                                                    </Button>
                                                                }

                                                                {selectedService?.length ? <Button color='main-color' className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100  w-md-auto text-nowrap" onClick={() => {
                                                                    const names = selectedService.map(row => row.serviceCode);
                                                                    let uniqueServices = Array.from(new Set(names))
                                                                    setServiceArray(uniqueServices);
                                                                    setMessageForPopUp(`Are you sure you want to delete the selected items?`)
                                                                    toggleModal(selectedService, "multi")
                                                                }}><i className="ri-delete-bin-5-line label-icon align-middle fs-16 me-1"></i>
                                                                    <span className="ps-2 ms-2 me-1"> Delete</span>
                                                                </Button> : null}
                                                            </div>
                                                            {viewPermission && viewPermission?.has("view") &&
                                                                <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                                                                    <i className="ri-settings-2-line fs-4"></i>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                )}
                                                icons={{
                                                    DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                }}
                                            />
                                            : null
                                        }
                                    </Row>
                                </CardBody>
                                {/* </Card> */}
                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
            </div>
            <CommonModal modalHeader={'Delete Service'}  messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(serviceName, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }} open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Yes, Delete It"} modalAction={() => {
                if (modal) {
                    dispatch(deleteService(serviceName, setLoading))
                    toggleModal(serviceName, "single");
                }
                else {
                    let jsonObj = { ids: serviceArray, type: "Service" }
                    dispatch(bulkDelete(jsonObj, setLoading))
                    setSelectAllService(false)
                    setSelectedService([])
                    toggleModal(selectedRowsForBulkDelete, "multi")
                }
            }} />
        </React.Fragment>
    )
}
export default ServicesListings;